const SearchConstValues = {
    MySelf_Id: '%MYSELF_ID%',
    MySelf: '%MYSELF%',
    Today: 'TODAY',
    DaysBeforeToday: 'DAYS BEFORE TODAY',
    DaysAfterToday: 'DAYS AFTER TODAY',
    Empty: '%EMPTY%',
    NotEmpty: '%NOTEMPTY%',
};
export default SearchConstValues;
